/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState, useRef, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

import classNames from 'classnames';
import { Section, SectionContainer } from '@components/Section';

import Text from '@hiredigital/ui/Text/Text';
import BlogHero from '@components/PageComponents/Hero/BlogPostHero';

// Can simplify
// import Main from '@components/Blog/Layout/Main';
// import Content from '@components/Blog/Layout/Content';
// import AsideLeft from '@components/Blog/Layout/AsideLeft';
// import AsideRight from '@components/Blog/Layout/AsideRight';

// Can simplify

import Sticky from '@components/Blog/Layout/Sticky';

import BlogSubscribe from '@components/Subscribe/BlogSubscribe';
import Signup from '@components/Signup/SmallCard';
import SocialMediaShare from '@components/Blog/SocialMediaShare';
// import NextArticle from '@components/Blog/NextArticle';
import { mapApiToCard } from '@helpers/userMap';
// import { estimateReadTime } from '@hiredigital/lib/helpers/utils';
// import toast from 'react-hot-toast';
import FilePreview from '@hiredigital/ui/FilePreview/FilePreview';
import IconExpand from '@hiredigital/ui/Icon/icons/expand-cross.inline.svg';
import IconCopy from '@hiredigital/ui/Icon/icons/copy-file.inline.svg';

import LayoutStyles from './Layout/Layout.module.scss';
import Styles from './BlogDetail.module.scss';

const Author = dynamic(() => import('@components/Blog/Author'));
const Breadcrumbs = dynamic(() => import('@components/Blog/Breadcrumbs'));
// const ReadTime = dynamic(() => import('@components/Blog/ReadTime'), {
//   ssr: false,suspense: true
// });

const TableContents = dynamic(() => import('@components/Blog/TableContents'), {
  suspense: true,
});

const NextArticle = dynamic(() => import('@components/Blog/NextArticle'), {
  suspense: true,
});

const Tags = dynamic(() => import('@components/SkillSet/Tags'), {
  suspense: true,
});
const TalentCard = dynamic(() => import('@components/TalentCard/TalentCard'), {
  suspense: true,
});
const SharePost = dynamic(() => import('@components/Blog/SharePost'), {
  suspense: true,
});
const BlogStoryList = dynamic(() => import('@components/Story/BlogStoryList'), {
  suspense: true,
});
const LongCTA = dynamic(() => import('@components/Blog/LongCTA'), {
  suspense: true,
});
const Accordion = dynamic(() => import('@hiredigital/ui/Accordion/Accordion'), {
  suspense: true,
});

// const EARLY_DETECT_TOP = 250;
// const EARLY_DETECT_BOTTOM = 150;

const BlogDetail = ({
  title,
  date,
  featuredImage,
  description,
  categories,
  content,
  relatedStories,
  postUrl,
  apiAuthor,
  author,
  tags,
  faqSettings,
  showBreadcrumbs = true,
}) => {
  const parentElement = useRef();
  const blogSubscribeRef = useRef();
  // const signupRef = useRef();
  const socialShareRef = useRef();
  const nextArticleRef = useRef();
  const tableContentsRef = useRef();

  // const asideElems = [
  //   blogSubscribeRef.current,
  //   signupRef.current,
  //   socialShareRef.current,
  //   nextArticleRef.current,
  //   tableContentsRef.current,
  // ];

  const [isImageExpanded, setIsImageExpanded] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [imageTitle, setImageTitle] = useState('');
  const [contents, setContents] = useState([]);
  const [isParentReady, setIsParentReady] = useState(false);
  const [hasCode, setHasCode] = useState(false);
  // const isOverlapping = (outMarginElem, asideElem) => {
  //   if (!outMarginElem || !asideElem) return false;

  //   const aRect = outMarginElem.getBoundingClientRect();
  //   const bRect = asideElem.getBoundingClientRect();

  //   return !(
  //     aRect.right < bRect.left ||
  //     aRect.left > bRect.right ||
  //     aRect.bottom + EARLY_DETECT_BOTTOM < bRect.top ||
  //     aRect.top - EARLY_DETECT_TOP > bRect.bottom
  //   );
  // };

  // const observeIntersecting = (parent) => {
  //   if (parent) {
  //     const outMarginElems = parent.querySelectorAll('.out-of-margin');
  //     asideElems.forEach((el) => {
  //       if (!el) return;
  //       const isColliding = Array.from(outMarginElems).some((o) => isOverlapping(o, el));
  //       if (isColliding) {
  //         el.classList.add('fadeOut');
  //       } else {
  //         el.classList.remove('fadeOut');
  //       }
  //     });
  //   }
  // };

  // const enableTransition = (elems) => {
  //   elems.forEach((el) => {
  //     if (!el) return;
  //     if (!el.classList.contains('transition')) {
  //       el.classList.add('transition');
  //     }
  //   });
  // };

  // const makeCodeBlockCopyable = (parent) => {
  //   if (parent) {
  //     const blocks = parent.querySelectorAll('pre');

  //     blocks.forEach((block) => {
  //       setHasCode(true);
  //       if (!block) return;
  //       const hasCopyAction = !!block?.querySelectorAll(`button.${Styles.actionCopy}`)?.length;
  //       if (hasCopyAction) return;
  //       // only add button if browser supports Clipboard API
  //       if (navigator.clipboard) {
  //         const btn = document.createElement('button');
  //         btn.classList.add(Styles.actionCopy);
  //         const root = createRoot(btn);
  //         root.render(
  //           <Fragment>
  //             {`Copy`}
  //             <IconCopy />
  //           </Fragment>
  //         );
  //         btn.addEventListener('click', copy);
  //         block.appendChild(btn);
  //       }
  //     });
  //   }
  // };

  const copy = async (e) => {
    try {
      // toast.dismiss();
      const button = e.srcElement;
      const pre = button.closest('pre');
      const code = pre.querySelector('code');
      const text = code.innerText;
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.warn('Fail to copy code!');
    } finally {
      // toast.success('Copied!');
    }
  };

  const expand = (src, title = '') => {
    setImageUrl(src);
    setImageTitle(title);
    setIsImageExpanded(!isImageExpanded);
  };

  useEffect(() => {
    disableWindowScroll(isImageExpanded);
  }, [isImageExpanded]);

  const disableWindowScroll = (b) => {
    if (!document) return;
    document.body.style.overflow = b ? 'hidden' : 'auto';
  };

  // const makeImageExpandable = (parent) => {
  //   if (parent) {
  //     const elems = parent.querySelectorAll('.wp-block-image');
  //     elems.forEach((el) => {
  //       if (!el) return;
  //       const hasExpand = !!el?.querySelectorAll(`button.${Styles.actionExpand}`)?.length;
  //       if (hasExpand) return;

  //       const img = el.querySelector('img');
  //       if (!img) return;

  //       const source = el.querySelectorAll("source[type='image/webp']")?.[0];
  //       const container = img.closest('figure');

  //       if (!container) return;

  //       const url = source?.getAttribute('srcset') || img.getAttribute('src');
  //       const alt = img.getAttribute('alt');

  //       const btn = document.createElement('button');
  //       btn.classList.add(Styles.actionExpand);
  //       btn.addEventListener('click', () => expand(url, alt));
  //       const root = createRoot(btn);
  //       root.render(<IconExpand />);

  //       container.classList.add(Styles.imgContainer);
  //       container.appendChild(btn);
  //     });
  //   }
  // };

  const createTableContents = (parent) => {
    if (!parent) return;
    const elems = parent.querySelectorAll('h2');
    const items = [];
    elems.forEach((el, idx) => {
      if (!el) return;
      const id = el.getAttribute('id');
      const target = id || `untitled_${idx}`;
      if (!id) {
        el.setAttribute('id', target);
      }
      items.push({ title: el.textContent, target });
    });
    setContents(items);
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && hasCode) {
      const addScript = document.createElement('script');
      addScript.setAttribute('src', '/scripts/prism.js');
      document.body.appendChild(addScript);

      addScript.onload = function () {
        window.Prism.highlightAll();
      };
    }
  }, [hasCode]);

  // const onScroll = () => {
  //   const elem = parentElement.current;
  //   if (elem) {
  //     observeIntersecting(elem);
  //   }
  // };

  useEffect(() => setIsParentReady(!!parentElement.current), [parentElement]);

  useEffect(() => {
    if (isParentReady && content) {
      const elem = parentElement.current;
      // makeCodeBlockCopyable(elem);
      // makeImageExpandable(elem);
      createTableContents(elem);
      // enableTransition(asideElems);

      // window.addEventListener('scroll', onScroll);
      // return () => window.removeEventListener('scroll', onScroll);
    }
  }, [content, isParentReady]);

  const categoryLinkTo = `/blog/categories/${categories?.nodes[0].name
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace('.', '')}`;

  const stories = relatedStories;

  return (
    <>
      <div className={Section.Styles.ruler}>
        <div className={Styles.container}>
          <BlogHero
            title={title}
            date={`Published ${date}`}
            featuredImage={featuredImage?.node?.sourceUrl}
            excerpt={description}
          />

          <div className={Styles.wrapper}>
            <div className={LayoutStyles.main}>
              <div className={LayoutStyles.asideLeft}>
                <Sticky top={90} wrapperProps={{ height: '85%', top: '150px' }}>
                  <Suspense>
                    <TableContents ref={tableContentsRef} list={contents} />
                  </Suspense>
                  <SocialMediaShare ref={socialShareRef} postUrl={postUrl} postTitle={title} />
                </Sticky>
                {!!stories?.length && (
                  <Sticky top={90} wrapperProps={{ height: 'calc(15% - 150px)', top: '150px' }}>
                    <Suspense>
                      <NextArticle
                        ref={nextArticleRef}
                        data={{
                          title: stories[0]?.title,
                          tag: stories[0]?.tags?.nodes?.[0]?.name,
                          featuredImage: stories[0]?.featuredImage?.node?.sourceUrl,
                          to: `/blog/${stories[0]?.slug}`,
                        }}
                      />
                    </Suspense>
                  </Sticky>
                )}
              </div>
              <div className={LayoutStyles.content}>
                {showBreadcrumbs && (
                  <Breadcrumbs
                    items={[
                      { text: 'Insights', to: '/blog' },
                      {
                        text:
                          categories?.nodes[0].name.charAt(0).toUpperCase() +
                          categories?.nodes[0].name.slice(1),
                        to: categoryLinkTo,
                      },
                    ]}>
                    {/*<ReadTime minutes={estimateReadTime(content)} />*/}
                  </Breadcrumbs>
                )}
                <Author author={apiAuthor} fallbackAuthor={author?.node} date={date} />
                <div className={classNames(Styles.text, Styles.wp)}>
                  {content && (
                    <div
                      ref={parentElement}
                      dangerouslySetInnerHTML={{ __html: content }}
                      strategy='lazyOnload'
                      style={{ backgroundColor: 'white' }}
                    />
                  )}
                  <FilePreview
                    title={imageTitle}
                    preview={imageUrl}
                    isOpen={isImageExpanded}
                    setIsOpen={setIsImageExpanded}
                  />
                </div>
                {faqSettings?.title && (
                  <Text element='h2' size={Text.Size.SUBHEADLINE} style={{ marginBottom: '16px' }}>
                    {faqSettings?.title}
                  </Text>
                )}

                {faqSettings?.faq && (
                  <Suspense>
                    <Accordion
                      data={faqSettings?.faq
                        ?.filter((o) => o?.question)
                        ?.map((o) => ({ title: o.question, content: o.answer }))}
                      style={{ marginBottom: '50px' }}
                    />
                  </Suspense>
                )}
                {tags?.nodes ? (
                  <div className={Styles.tags}>
                    <h4 className={Styles.talentAuthorFooter}>{`Keywords`}</h4>
                    <Suspense>
                      <Tags tags={tags?.nodes} count={tags?.nodes.length} isWp />
                    </Suspense>
                  </div>
                ) : (
                  ''
                )}
                <Suspense>
                  <SharePost postUrl={postUrl} postTitle={title} />
                </Suspense>
                {apiAuthor ? (
                  <Fragment>
                    {/* <h4 className={Styles.talentAuthorFooter}>{`About the Author`}</h4> */}
                    <div className={Styles.talentAuthorFooter}>
                      <Suspense>
                        <TalentCard author={true} user={mapApiToCard(apiAuthor)} />
                      </Suspense>
                    </div>
                  </Fragment>
                ) : (
                  ''
                )}
              </div>
              <div className={LayoutStyles.asideRight}>
                <Sticky top={90} wrapperProps={{ top: '150px', height: '25%' }}>
                  {/*<Signup ref={signupRef} />*/}
                </Sticky>
                <Sticky top={90} wrapperProps={{ height: 'calc(75% - 150px)', top: '150px' }}>
                  <Suspense>
                    <BlogSubscribe ref={blogSubscribeRef} aside={true} />
                  </Suspense>
                </Sticky>
              </div>
            </div>
          </div>
        </div>
        <Suspense>
          <LongCTA />
        </Suspense>
        <div>
          {stories && (
            <Suspense>
              <SectionContainer>
                <Section>
                  <BlogStoryList list={stories} />
                </Section>
              </SectionContainer>
            </Suspense>
          )}
          <BlogSubscribe />
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
